// extracted by mini-css-extract-plugin
export var content = "_pr-1";
export var noScroll = "_pr-3";
export var paper = "_pr-0";
export var scrollable = "_pr-2";